module.exports = __webpack_public_path__ + "static/media/chaticon.0838ce86.svg";